import { render, staticRenderFns } from "./InputPlug.vue?vue&type=template&id=01b96b81&"
import script from "./InputPlug.vue?vue&type=script&lang=js&"
export * from "./InputPlug.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports